import { lazy } from "react";

const routes = [
  {
    path: "/settings/banks",
    element: lazy(() => import("../../pages/Settings/Banks")),
  },
];

export default routes;
